/**
 * Lightweight MailChecker utility
 * Validates email structure and rejects disposable, temporary, and placeholder domains
 * while preserving all legitimate business, educational, and public email domains.
 */

const DISPOSABLE_OR_DUMMY_DOMAINS = new Set([
  // Dummy / placeholder domains
  "xyz.com",
  "test.com",
  "testing.com",
  "example.com",
  "example.org",
  "example.net",
  "sample.com",
  "fake.com",
  "fakemail.com",
  "foo.com",
  "bar.com",
  "abc.com",
  "asdf.com",
  "qwerty.com",
  "invalid.com",
  "none.com",
  "dummy.com",
  "placeholder.com",
  "temp.com",

  // Disposable / temporary mail services
  "mailinator.com",
  "tempmail.com",
  "temp-mail.org",
  "10minutemail.com",
  "10minutemail.net",
  "guerrillamail.com",
  "guerrillamail.net",
  "guerrillamail.biz",
  "guerrillamail.org",
  "sharklasers.com",
  "yopmail.com",
  "yopmail.fr",
  "yopmail.net",
  "dispostable.com",
  "throwawaymail.com",
  "trashmail.com",
  "trashmail.net",
  "getairmail.com",
  "mohmal.com",
  "crazymailing.com",
  "fakemailgenerator.com",
  "nada.ltd",
  "getnada.com",
  "emailondeck.com",
  "maildrop.cc",
  "inboxkitten.com",
  "burnermail.io",
  "dropmail.me",
  "mytemp.email",
  "generator.email",
  "tempail.com",
  "disposablemail.com",
]);

export const isValidEmail = (email) => {
  if (!email || typeof email !== "string") return false;

  const trimmed = email.trim().toLowerCase();
  // Basic structural RFC email check
  const basicRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!basicRegex.test(trimmed) || trimmed.includes("..")) {
    return false;
  }

  const parts = trimmed.split("@");
  if (parts.length !== 2) return false;

  const [user, domain] = parts;
  if (!user || user.length > 64) return false;
  if (!domain || domain.length > 255) return false;

  // Block top-level domain without extension or invalid domain structure
  const domainParts = domain.split(".");
  if (domainParts.length < 2) return false;
  const tld = domainParts[domainParts.length - 1];
  if (tld.length < 2) return false;

  // Check against disposable / dummy domain list
  if (DISPOSABLE_OR_DUMMY_DOMAINS.has(domain)) {
    return false;
  }

  return true;
};

const mailchecker = {
  isValid: isValidEmail,
};

export default mailchecker;
